



























































































































import Pagination from "@/components/Pagination/index.vue"; // Secondary package based on el-pagination
import { Vue, Component } from "vue-property-decorator";
import path from "path";
import { deepClone } from "@/utils";
import { asyncRoutes } from "@/router";
import i18n from "@/lang";
import {
  CompanyCommonReq,
  geCompanys,
  createCompany,
  updateCompany,
  deleteCompany,
} from "@/api/company";
import { RouteConfig } from "vue-router";
import { ResCode, Company, Admin } from "@/api/baseDefine";
import { ElTree, TreeData } from "element-ui/types/tree";
import { ElStep } from "element-ui/types/step";
import {
  newAdmin,
  NewAdminReq,
  AdminCommonReq,
  users,
  getQiniuToken,
} from "@/api/admin";
import * as uuid from "uuid";
import { ElForm } from "element-ui/types/form";
/**
 * 包含所有功能的表单
 *
 * @export
 * @class ComplexTable
 * @extends {Vue}
 */
@Component({})
export default class AddAdmin extends Vue {
  private admin: Admin = <Admin>{};
  private queryCompanys: Company[] = [];
  private loading = false;
  private frontRoles: string[] = [];

  public validateToAddAdmin() {
    (this.$refs.form as ElForm).validate((valid: boolean) => {
      if (valid) {
        this.add();
      } else {
        return false;
      }
    });
  }
  public async add() {
    let req = <AdminCommonReq>{};
    req.admin = this.admin;
    const res = await newAdmin(req);
    if (res && res.code === ResCode.SUCCESS) {
      this.$notify({
        title: this.$t("common.success").toString(),
        message: this.$t("notification.addAdminSuccess").toString(),
        type: "success",
      });
      this.$router.push("/admin/list");
    }
  }

  public async queryCompany(query) {
    let req: CompanyCommonReq = <CompanyCommonReq>{};
    let company: Company = <Company>{};
    req.page = 1;
    req.pageSize = 10;
    company.name = query;
    req.company = company;
    this.loading = true;
    const res = await geCompanys(req);
    if (res.code === ResCode.SUCCESS) {
      this.queryCompanys = res.data.companys.list;
      this.loading = false;
    }
  }
  public reset() {
    this.admin = <Admin>{};
  }

  public onSelectChangeCompany() {
    this.queryCompany("");
  }
  public async getUserList() {
    let req: AdminCommonReq = <AdminCommonReq>{};
    req.page = 1;
    req.pageSize = 1;
    const res = await users(req);
    if (!!res && res.code === ResCode.SUCCESS) {
      this.frontRoles = res.data.users.frontRoles;
    }
  }
  private uploadQiniuUrl: string = "https://up-z2.qiniup.com"; // 七牛云服务器地址
  private imageUrl = "";
  private beforeUploadGetKey() {
    this.qiniuData.key = "meter/admin/portrait/" + uuid.v1();
  }
  private successUploadGetKey(response, file, fileList) {
    this.imageUrl = this.qiniuData.domain + "/" + this.qiniuData.key;
    this.$notify({
      title: this.$t("common.success").toString(),
      message: this.$t("notification.UploadSuccess").toString(),
      type: "success",
      duration: 2000,
    });
    this.admin.portrait = this.imageUrl;
  }
  private qiniuData = {
    key: "", // 图片名字处理
    token: "", // 七牛云token
    domain: "",
  };
  public async qiniuToken() {
    const res = await getQiniuToken();
    if (res && res.code === ResCode.SUCCESS) {
      this.qiniuData.token = res.data.token;
      this.qiniuData.domain = res.data.domain;
    }
  }

  private created() {
    this.qiniuToken();
    this.getUserList();
  }

  public dataRules = {
    password: [
      { required: true, trigger: "blur", validator: this.validatePass },
    ],
    confirmPassword: [
      { required: true, trigger: "blur", validator: this.validatePass2 },
    ],
    name: [
      { required: true, trigger: "blur", validator: this.validateNotNull },
    ],
    email: [
      { required: true, trigger: "blur", validator: this.validateNotNull },
    ],
    userName: [
      { required: true, trigger: "blur", validator: this.validateNotNull },
    ],
    frontRole: [
      { required: true, trigger: "blur", validator: this.validateNotNull },
    ],
    phone: [
      { required: true, trigger: "blur", validator: this.validateNotNull },
    ],
    position: [
      { required: true, trigger: "blur", validator: this.validateNotNull },
    ],
    companyID: [
      { required: true, trigger: "blur", validator: this.validateNotNull },
    ],
  };

  private validateNotNull(rule: any, value: string, callback: any) {
    if (!value || value.length <= 0) {
      callback(new Error(this.$t("validate.valueNotNull").toString()));
    } else {
      callback();
    }
  }

  private validatePass(rule: any, value: string, callback: any) {
    if (value.length < 8) {
      callback(
        new Error(this.$t("validate.passwordMustGreaterThan8").toString())
      );
    } else {
      callback();
    }
  }
  private validatePass2(rule: any, value: string, callback: any) {
    if (value !== this.admin.password) {
      callback(new Error(this.$t("validate.twoPasswordNotEqual").toString()));
    } else {
      callback();
    }
  }
}
